import * as Yup from "yup";
import { SurveyRecordVerification } from "../../generated/graphql";
import { getInitialValues } from "../../services/config";

const getSchema = () => {
    return Yup.object().shape({
        verificationScope: Yup.mixed().nullable().default(null),
        verification: Yup.mixed().required().default(null),
        description: Yup.string().nullable().default(""),
        surveyRecordVerificationClassification: Yup.mixed().nullable().default(null),
        surveyRecordVerificationState: Yup.mixed().nullable().default(null),
    })
}

export default function surveyRecordVerificationFormInit(record?: Partial<SurveyRecordVerification>) {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}
